import {SearchType} from '../rules/constants';
import {advancedRawRuleDefaults} from '../rules/advancedRaw/defaults';
import {attributeHistoryRuleDefaults} from '../rules/attributeHistory/defaults';
import {cartRuleDefaults} from '../rules/cart/defaults';
import {categoryIdRuleDefaults} from '../rules/categoryId/defaults';
import {checkoutsRuleDefaults} from '../rules/checkouts/defaults';
import {contentsRuleDefaults} from '../rules/contents/defaults';
import {dateRuleDefaults} from '../rules/date/defaults';
import {expirationRuleDefaults} from '../rules/expiration/defaults';
import {fileAspectRuleDefaults} from '../rules/fileAspect/defaults';
import {fileFormatRuleDefaults} from '../rules/fileFormat/defaults';
import {fileFormatFamilyRuleDefaults} from '../rules/fileFormatFamily/defaults';
import {fileSizeRuleDefaults} from '../rules/fileSize/defaults';
import {keywordRuleDefaults} from '../rules/keyword/defaults';
import {metadataRuleDefaults} from '../rules/metadata/defaults';
import {savedSearchRuleDefaults} from '../rules/savedSearch/defaults';
import {userRuleDefaults} from '../rules/user/defaults';
import {visualRuleDefaults} from '../rules/visual/defaults';

import {BASE_RULE} from '../rules/baseRule';

const RuleDefaultsMap = <const>{
	[SearchType.ADVANCED_RAW]: advancedRawRuleDefaults,
	[SearchType.ATTRIBUTE_HISTORY]: attributeHistoryRuleDefaults,
	[SearchType.CART]: cartRuleDefaults,
	[SearchType.CATEGORY_ID]: categoryIdRuleDefaults,
	[SearchType.CHECKOUTS]: checkoutsRuleDefaults,
	[SearchType.CONTENTS]: contentsRuleDefaults,
	[SearchType.DATE]: dateRuleDefaults,
	[SearchType.EXPIRE]: expirationRuleDefaults,
	[SearchType.FILE_ASPECT]: fileAspectRuleDefaults,
	[SearchType.FILE_FORMAT]: fileFormatRuleDefaults,
	[SearchType.FILE_FORMAT_FAMILY]: fileFormatFamilyRuleDefaults,
	[SearchType.FILE_SIZE]: fileSizeRuleDefaults,
	[SearchType.KEYWORD]: keywordRuleDefaults,
	[SearchType.METADATA]: metadataRuleDefaults,
	[SearchType.SAVED_SEARCH]: savedSearchRuleDefaults,
	[SearchType.USER]: userRuleDefaults,
	[SearchType.VISUAL]: visualRuleDefaults,
};

export const getRuleDefaults = (type: SearchType) =>
	RuleDefaultsMap[type] || BASE_RULE;

export default getRuleDefaults;
